<template lang="pug">
  v-app(v-if="authenticated && !$route.path.includes('/reports/')")
    v-navigation-drawer(persistent, v-model="drawer", enable-resize-watcher, fixed, app)
      img(src="@/assets/logo.png", alt="Luamar", style="width: 80%; margin: 30px 10% 20px")
      v-list
        v-list-item(v-for="(item, i) in navigation", :key="i", :to="item.route", :exact="item.exact", ripple)
          v-list-item-action
            v-icon(v-html="item.icon")
          v-list-item-content
            v-list-item-title(v-text="item.title")
    v-app-bar(app, dark, color="primary")
      v-app-bar-nav-icon(@click.stop="drawer = !drawer")
      v-toolbar-title {{$t($route.name)}}
    v-main
      router-view
    // v-footer(app)
      v-spacer
      span &copy; Luamar {{new Date().getFullYear()}}
  v-app(v-else-if="$route.path.includes('/reports/')")
    v-app-bar(app)
      v-btn(icon)
        v-icon arrow_back
      v-spacer
      v-btn(icon)
        v-icon print
    v-layout(flex justify-center)
      div.print-page
        router-view
  v-app(v-else)
    v-main
      router-view
</template>

<style>
  @media only screen {
    .print-page {
      width: 1000px;
      height: 2000px;
      padding: 20px;
      margin: 20px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, .4);
    }
  }

  @media print {
    .print-page {
      width: 100%;
      margin: 0;
      padding: 0;
    }
    .toolbar {
      display: none;
    }
  }
</style>

<script>
export default {
  data() {
    return {
      navigation: [{
        icon: 'mdi-view-dashboard',
        title: 'Dashboard',
        route: '/',
        exact: true,
      }, {
        icon: 'mdi-home',
        title: 'Alojamientos',
        route: '/accommodations',
        exact: false,
      }, {
        icon: 'mdi-bookmark',
        title: 'Reservas',
        route: '/bookings',
        exact: false,
      }, {
        icon: 'mdi-bank',
        title: 'Facturas',
        route: '/invoices',
        exact: false,
      }, {
        icon: 'mdi-account-group',
        title: 'Usuarios',
        route: '/users',
        exact: false,
      }, {
        icon: 'mdi-star',
        title: 'Ofertas',
        route: '/sales',
        exact: false,
      }],
      drawer: true,
      title: 'Luamar',
    };
  },
  computed: {
    authenticated() {
      return store.state.user.authenticated;
    },
  },
  name: 'App',
};
</script>



// WEBPACK FOOTER //
// src/App.vue